import * as React from 'react'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import createStyles from '@material-ui/core/styles/createStyles'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import { WithStyles, Divider } from '@material-ui/core'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import { IOrderLineItem } from 'src/models/IOrder'

interface IReviewProps extends WithStyles<typeof styles> {
  lineItems: IOrderLineItem[]
  processingFee: number
}

class Review extends React.PureComponent<IReviewProps> {
  public render() {
    const { classes, lineItems, processingFee } = this.props
    const subTotal = lineItems.reduce(
      (sum, item) => (sum += item.price * item.quantity),
      0
    )
    const serviceCharge = Math.round(subTotal * processingFee * 100) / 100
    const total = subTotal + serviceCharge

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Order Summary
        </Typography>
        <List disablePadding>
          {lineItems.map(lineItem => (
            <ListItem className={classes.listItem} key={lineItem.description}>
              <ListItemText primary={lineItem.description} />
              <Typography variant="body1">
                {this.formatCurrency(lineItem.price * lineItem.quantity)}
              </Typography>
            </ListItem>
          ))}
          <Divider />
          <ListItem className={classes.listItem}>
            <ListItemText primary="Subtotal" />
            <Typography variant="subtitle1" className={classes.total}>
              {this.formatCurrency(subTotal)}
            </Typography>
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText primary="Processing fee" />
            <Typography variant="subtitle1" className={classes.total}>
              {this.formatCurrency(serviceCharge)}
            </Typography>
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText primary="Total" />
            <Typography variant="h5" className={classes.total}>
              {this.formatCurrency(total)}
            </Typography>
          </ListItem>
        </List>
      </React.Fragment>
    )
  }

  private formatCurrency = (value: number) => {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    })
  }
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    listItem: {
      padding: `${spacing.unit}px 0`
    },
    total: {
      fontWeight: 'bold'
    },
    title: {
      marginTop: spacing.unit * 2
    }
  })

export default withStyles(styles)(Review)



// WEBPACK FOOTER //
// ./src/components/contest/Review.tsx